@if (isInitialLoading) {
<app-profile-friends-skeleton></app-profile-friends-skeleton>
} @else {
<!-- DESKTOP VERSION -->
<div class="friends-page-wrapper d-none d-lg-block">
    <!-- <div class="page-content max-w-7xl mx-auto"> -->
    <div class="page-content">
        <div class="content-center w-100">
            <div class="friend-list-box section-b-space">
                <div class="card-title">
                    <div class="row w-100 mx-0 d-flex align-items-center">
                        <div class="col-lg-4 col-12 mb-4 lg:mb-0 text-center text-lg-start">
                            <h1 class="text-2xl font-bold text-slate-800 dark:text-white">{{ domain?.name || 'Les
                                célébrités' }}</h1>
                            <p class="text-slate-500 text-sm mt-1">Découvrez vos stars préférées à travers le monde
                            </p>
                        </div>
                        <div class="col-lg-8 col-12">

                            <div class="flex flex-wrap md:flex-nowrap items-center gap-4 justify-center lg:justify-end">
                                <div class="relative w-full md:w-auto md:min-w-160">
                                    <label
                                        class="block text-teny-10 uppercase font-bold text-slate-400 mb-1 ml-1 tracking-wider">Domaine</label>
                                    <div class="relative">
                                        <select [formControl]="domainControl"
                                            class="w-full appearance-none bg-slate-50 dark:bg-slate-800 border-none rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-primary cursor-pointer pr-10">
                                            <option value="Tous">Tous</option>
                                            @for (domain of domains; track domain.id) {
                                            <option [value]="domain.id">{{ domain.name }}</option>
                                            }
                                        </select>
                                        <span
                                            class="material-icons absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">expand_more</span>
                                    </div>
                                </div>
                                <div class="relative w-full md:w-auto md:min-w-160">
                                    <label
                                        class="block text-teny-10 uppercase font-bold text-slate-400 mb-1 ml-1 tracking-wider">Pays</label>
                                    <div class="relative">
                                        <select [formControl]="countryControl"
                                            class="w-full appearance-none bg-slate-50 dark:bg-slate-800 border-none rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-primary cursor-pointer pr-10">
                                            <option value="Tous">Tous</option>
                                            @for (country of countries; track country.id) {
                                            <option [value]="country.id">{{ country.name }}</option>
                                            }
                                        </select>
                                        <span
                                            class="material-icons absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">expand_more</span>
                                    </div>
                                </div>
                                <div class="relative w-full md:w-auto md:min-w-160">
                                    <label
                                        class="block text-teny-10 uppercase font-bold text-slate-400 mb-1 ml-1 tracking-wider">Trier
                                        par</label>
                                    <div class="relative">
                                        <select [formControl]="sortControl"
                                            class="w-full appearance-none bg-slate-50 dark:bg-slate-800 border-none rounded-lg px-4 py-2.5 text-sm focus:ring-2 focus:ring-primary cursor-pointer pr-10">
                                            <option value="popularity">Popularité</option>
                                            <option value="alphabetical">Ordre alphabétique</option>
                                        </select>
                                        <span
                                            class="material-icons absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">sort</span>
                                    </div>
                                </div>
                                <div class="relative pt-5 w-full md:w-auto md:min-w-160">
                                    <div class="relative">
                                        <span
                                            class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">search</span>
                                        <input
                                            class="pl-9 pr-4 py-2.5 bg-blue-50/50 dark:bg-slate-800/50 border-none rounded-lg text-sm w-full focus:ring-2 focus:ring-primary"
                                            placeholder="Recherche..." type="text" [formControl]="searchControl" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="friend-list friend-page-list">
                        <div class="row g-4">
                            @if (filteredData.length > 0) {
                            @for (item of filteredData; track item) {
                            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 d-flex align-items-stretch">
                                <div
                                    class="celebrity-card-compact max-w-sm mx-auto w-full h-full bg-white dark:bg-slate-900 rounded-2xl shadow-xl overflow-hidden border border-slate-100 dark:border-slate-800 transition-all duration-300 hover:shadow-2xl mb-3 flex flex-col">
                                    <div class="relative h-14 bg-slate-50 dark:bg-slate-800 profile-bg">
                                        <div
                                            class="absolute inset-0 bg-gradient-to-b from-transparent to-white dark:to-slate-900">
                                        </div>
                                    </div>
                                    <div class="px-3 pb-3 -mt-8 relative flex flex-col items-center flex-1">
                                        <div class="relative mb-2">
                                            <div (click)="item.profile_picture && !item._hideImage ? openImagePreview(item.profile_picture) : null"
                                                class="w-20 h-20 rounded-full border-2 border-white dark:border-slate-900 shadow-lg overflow-hidden bg-slate-200 cursor-pointer flex items-center justify-center">
                                                @if (item.profile_picture && !item._hideImage) {
                                                <img [src]="item.profile_picture"
                                                    (error)="handleImageError($event, item)" [alt]="item.scene_name"
                                                    class="w-full h-full object-cover">
                                                } @else {
                                                <div class="w-full h-full flex items-center justify-center text-white font-bold text-4xl"
                                                    [style.backgroundColor]="getAvatarColor(item.scene_name)" style="font-size: 24px;">
                                                    {{ getUserInitial(item.scene_name) }}
                                                </div>
                                                }
                                            </div>
                                            <div *ngIf="item.official === '1'"
                                                class="absolute bottom-0 right-0 w-5 h-5 bg-primary text-white rounded-full border-2 border-white dark:border-slate-850 flex items-center justify-center shadow-sm"
                                                style="right: 0 !important; bottom: 0 !important;">
                                                <span class="material-icons" style="font-size: 12px;">verified</span>
                                            </div>
                                        </div>
                                        <div class="text-center mb-1.5">
                                            <div class="flex items-center justify-center gap-1 mb-0.5">
                                                <h2
                                                    class="text-base font-bold text-slate-900 dark:text-white tracking-tight">
                                                    {{ item.scene_name }}
                                                </h2>
                                            </div>
                                            <div
                                                class="flex items-center justify-center text-primary font-medium text-xs tracking-wide">
                                                <span class="uppercase font-bold">{{ item.domain?.name || 'Artiste' }}</span>
                                            </div>
                                        </div>
                                        <div class="card-actions mt-2">
                                            <a [routerLink]="['/profile/celebrity', getEncodedId(item.id)]"
                                                class="card-action-link group no-underline">
                                                <span>Voir le profil</span>
                                                <span class="material-icons card-action-icon">arrow_forward</span>
                                            </a>
                                            <button (click)="toggleFollow(item, $event)" type="button"
                                                class="card-action-follow" [class.is-following]="isFollowing(item)">
                                                <span class="material-icons">{{ isFollowing(item) ? 'person' :
                                                    'person_add' }}</span>
                                                <span>{{ isFollowing(item) ? 'Suivi' : 'Suivre' }}</span>
                                            </button>
                                        </div>
                                        <div class="card-stats">
                                            <span class="card-stats-count">{{ formatFollowers(item.followers_count
                                                || 0)
                                                }}</span>
                                            <span class="card-stats-label">{{ item.followers_count <= 1 ? 'abonné'
                                                    : 'abonnés' }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            } @else {
                            <div
                                class="p-12 md:p-24 bg-slate-50/30 dark:bg-transparent flex flex-col items-center text-center">
                                <div
                                    class="w-24 h-24 md:w-32 md:h-32 bg-blue-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-8">
                                    <span
                                        class="material-symbols-outlined text-primary text-6xl md:text-7xl font-light">person_search</span>
                                </div>
                                <h2 class="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white mb-4">
                                    Aucune
                                    star trouvée</h2>
                                <p class="text-slate-500 dark:text-slate-400 text-base md:text-lg max-w-md mb-10">
                                    Il n'y a pas encore de célébrités enregistrées dans ce domaine pour le moment.
                                </p>
                                <button (click)="resetFilters()"
                                    class="bg-primary hover:bg-opacity-90 text-white font-semibold py-3 px-8 rounded-xl transition-all border border-slate-900 dark:border-white/20 shadow-lg shadow-primary/25 flex items-center gap-2 button-filter-custom">
                                    <span class="material-icons text-xl">filter_list_off</span>
                                    Réinitialiser les filtres
                                </button>
                            </div>
                            }
                        </div>
                        @if (isLoading) {
                        <div class="text-center py-4">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Chargement...</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- ================= MOBILE VERSION ================= -->
<div class="container-fluid d-block d-lg-none px-3 py-3">

    <!-- HEADER -->
    <div class="mb-4">
        <h2 class="fw-bold text-dark my-2">
            {{ domain?.name || 'Les célébrités' }}
        </h2>
        <p class="text-slate-500 text-sm">Découvrez vos stars préférées à travers le monde</p>
    </div>

    <!-- SEARCH -->
    <div class="mb-3 position-relative">
        <span class="material-icons position-absolute top-50 start-0 translate-middle-y ms-3 text-muted">
            search
        </span>
        <input type="text" class="form-control rounded-lg ps-5 py-2" placeholder="Rechercher une célébrité"
            [formControl]="searchControl" />
    </div>

    <!-- FILTERS (pills style) -->
    <div class="d-flex gap-2 mb-4">

        <!-- Domaine -->
        <select class="form-select rounded-lg fw-semibold" [formControl]="domainControl">
            <option value="Tous">DOMAINE</option>
            @for (domain of domains; track domain.id) {
            <option [value]="domain.id">{{ domain.name }}</option>
            }
        </select>

        <!-- Pays -->
        <select class="form-select rounded-lg" [formControl]="countryControl">
            <option value="Tous">PAYS</option>
            @for (country of countries; track country.id) {
            <option [value]="country.id">{{ country.name }}</option>
            }
        </select>

        <!-- Trier -->
        <select class="form-select rounded-lg" [formControl]="sortControl">
            <option value="popularity">TRIER PAR</option>
            <option value="alphabetical">Ordre alphabétique</option>
        </select>

    </div>

    <!-- LIST -->
    <div class="d-flex flex-column gap-3">

        @if (filteredData.length > 0) {
        @for (item of filteredData; track item) {

        <div class="card border-0 shadow-sm rounded-lg p-3">

            <div class="d-flex align-items-center gap-3">

                <!-- Avatar -->
                <div class="position-relative">
                    <div class="rounded-circle overflow-hidden" style="width:70px;height:70px;">
                        @if (item.profile_picture && !item._hideImage) {
                        <img [src]="item.profile_picture" class="w-100 h-100 object-fit-cover">
                        } @else {
                        <div class="w-100 h-100 d-flex align-items-center justify-content-center text-white fw-bold"
                            [style.backgroundColor]="getAvatarColor(item.scene_name)" style="font-size: 24px;">
                            {{ getUserInitial(item.scene_name) }}
                        </div>
                        }
                    </div>

                    <!-- Verified -->
                    <div *ngIf="item.official === '1'"
                        class="absolute bottom-0 right-0 w-5 h-5 bg-primary text-white rounded-full border-2 border-white dark:border-slate-850 flex items-center justify-center z-10 shadow-sm"
                        style="right: 0 !important; bottom: 0 !important;">
                        <span class="material-icons" style="font-size: 12px;">verified</span>
                    </div>
                </div>

                <!-- Info -->
                <div class="flex-grow-1">

                    <div class="fw-bold text-dark">
                        {{ item.scene_name }}
                    </div>

                    <div class="text-warning small fw-semibold text-uppercase">
                        {{ item.domain?.name || 'Artiste' }}
                    </div>

                    <div class="text-muted small">
                        {{ formatFollowers(item.followers_count || 0) }} followers
                    </div>

                </div>

                <!-- Follow icon -->
                <button class="btn btn-light w-10 h-10 d-flex align-items-center justify-content-center rounded-full"
                    (click)="toggleFollow(item, $event)">
                    <span class="material-icons text-warning">
                        {{ isFollowing(item) ? 'person' : 'person_add' }}
                    </span>
                </button>

            </div>

            <!-- Actions -->
            <div class="d-flex gap-2 mt-3">

                <a [routerLink]="['/profile/celebrity', getEncodedId(item.id)]"
                    class="btn btn-warning-style flex-fill rounded-lg fw-semibold">
                    Voir le profil
                </a>

                <button class="btn btn-outline-secondary rounded-lg" (click)="toggleFollow(item, $event)">
                    {{ isFollowing(item) ? 'Suivi' : 'Suivre' }}
                </button>

            </div>

        </div>

        }
        }

        @else {
        <div class="p-12 md:p-24 bg-slate-50/30 dark:bg-transparent flex flex-col items-center text-center">
            <div
                class="w-24 h-24 md:w-32 md:h-32 bg-blue-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-8">
                <span
                    class="material-symbols-outlined text-primary text-6xl md:text-7xl font-light">person_search</span>
            </div>
            <h2 class="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white mb-4">Aucune
                star trouvée</h2>
            <p class="text-slate-500 dark:text-slate-400 text-base md:text-lg max-w-md mb-10">
                Il n'y a pas encore de célébrités enregistrées dans ce domaine pour le moment.
            </p>
            <button (click)="resetFilters()"
                class="bg-primary hover:bg-opacity-90 text-white font-semibold py-3 px-8 rounded-xl transition-all border border-slate-900 dark:border-white/20 shadow-lg shadow-primary/25 flex items-center gap-2 button-filter-custom">
                <span class="material-icons text-xl">filter_list_off</span>
                Réinitialiser les filtres
            </button>
        </div>
        }

    </div>

    <!-- LOAD MORE -->
    @if (hasMore && !isLoading) {
    <div class="text-center mt-4">
        <button class="btn btn-warning rounded-pill px-4" (click)="loadMore()">
            Charger plus
        </button>
    </div>
    }

</div>
}